var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMedi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "mediCircle",
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#2F2F2F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.178 27.655C30.178 32.9871 25.8848 37.3097 20.5892 37.3097C15.2935 37.3097 11 32.9871 11 27.655C11 22.3229 15.2932 18 20.5892 18C25.8852 18 30.178 22.3229 30.178 27.655Z",
    fill: "#AAAAAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6971 27.6549C40.6971 32.6739 38.5505 36.7443 35.9025 36.7443C33.2545 36.7443 31.1079 32.6739 31.1079 27.6549C31.1079 22.6358 33.2542 18.5654 35.9022 18.5654C38.5502 18.5654 40.6968 22.6345 40.6968 27.6549",
    fill: "#AAAAAA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0001 27.6549C45.0001 32.1508 44.2453 35.7976 43.3139 35.7976C42.3825 35.7976 41.6279 32.1517 41.6279 27.6549C41.6279 23.1581 42.3828 19.5122 43.3139 19.5122C44.245 19.5122 45.0001 23.1578 45.0001 27.6549Z",
    fill: "#AAAAAA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMedi);
export default __webpack_public_path__ + "static/media/icon_medi.06b470a785f9df9a719ec4974288c685.svg";
export { ForwardRef as ReactComponent };